const local = '_PROVIDER_ORGAOS_APOIADOS_FOLLOWAIR_'
import Vue from 'vue'

var update = false

export default {
	methods: {
		_GET_ORGAO_APOIADO: function (callback) {
			this._httpGet('/Orgao_apoiado/get', function (retorno) {
				if (retorno._request && retorno._status) {
					callback(retorno.lista.length > 0 ? retorno.lista : null)
				} else {
					callback(null)
				}
			})
		},

		_providerOrgaoApoiadoUpdate: function () {
			//console.log("update orgao apoiado")
			// ESTADOS
			this._GET_ORGAO_APOIADO(function (lista) {
				if (lista != null) {
					var string = JSON.stringify(lista)
					sessionStorage.setItem(local, string)
				}
			})
		},

		_providerOrgaoApoiado: function (callback) {
			//console.log("update orgao apoiado", update)

			if (!update) {
				update = true
				this._GET_ORGAO_APOIADO(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}

			// se existir config do cliente
			if (sessionStorage.getItem(local) != null) {
				callback(JSON.parse(sessionStorage.getItem(local)))
			} else {
				this._GET_ORGAO_APOIADO(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}
		}
	}
}